import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const createTicket = async (bussinessUuid, data) => {
  try {
    let resp = await http.post(`${URL}/ticket/${bussinessUuid}/create`, data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getAllTickets = async (businessId) => {
  try {
    let resp = await http.get(`${URL}/ticket/${businessId}/get-ticket`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const addTicketNoteService = async (bussinessUuid, ticketId, data) => {
  try {
    let resp = await http.put(
      `${URL}/ticket/${bussinessUuid}/${ticketId}/add-note`,
      data
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
